import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const userAgent = window.navigator.userAgent.toLowerCase();

const inMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
console.log("inMobile:", inMobile, !inMobile);

const router = new Router({
  routes: [
    {
      path: "",
      redirect: "/index"
    },
    {
      path: "/index",
      name: "Index",
      meta: {
        type: "index"
      },
      component: () => import("@/components/website")
    },
    //线上分享页，建议不要修改
    {
      path: "/videoShare",
      name: "VideoShare",
      meta: {
        title: "晓讲师"
      },
      component: () => import("@/components/videoShare")
    },
    //线上目录分享页，建议不要修改
    {
      path: "/catalogueShare",
      name: "CatalogueShare",
      meta: {
        title: "晓讲师"
      },
      component: () => import("@/components/catalogueShare")
    },
    //线上主页分享页，建议不要修改
    {
      path: "/homepage",
      name: "homepage",
      meta: {
        title: "晓讲师"
      },

      component: () => import("../components/homepage")
    },
    {
      path:'/video',
      name:"video",
      beforeEnter:(to, from, next) => {
        if (inMobile) {
          next({
            path: '/m/video',
            params: to.params,
            query: to.query
          });
        } else {
          next({
            path: '/p/video',
            params: to.params,
            query: to.query
          })
      }}
    },
        {
      path:'/home',
      name:"home",
      beforeEnter:(to, from, next) => {
        if (inMobile) {
          next({
            path: '/m/home',
            params: to.params,
            query: to.query
          });
        } else {
          next({
            path: '/p/home',
            params: to.params,
            query: to.query
          })
      }}
    },
    //pc端路由
    {
      path: "/p",
      name: "pc",
      beforeEnter: (to, from, next) => {
        if (inMobile) {
          next({
            path: to.path.replace("/p/", "/m/"),
            params: to.params,
            query: to.query
          });
        } else {
          next();
        }
      },
      component: () => import("@/Layout/pc.vue"),
      children: [
        {
          path: "video",
          name: "pcVideo",
          meta: {
            title: "晓讲师"
          },
          component: () => import("@/views/pc/Video/index.vue")
        },
        {
          path: "home",
          name: "pcHome",
          meta: {
            title: "晓讲师"
          },
          component: () => import("@/views/pc/Home/index.vue")
        },
        {
          path: "history",
          name: "pcHistory",
          meta: {
            title: "历史记录"
          },
          component: () => import("@/views/pc/History/index.vue")
        }
      ]
    },
    //移动端路由
    {
      path: "/m",
      name: "mobile",
      beforeEnter: (to, from, next) => {
        console.log(to)
        if (inMobile) {
          next()
        } else {
          next({
            path: to.path.replace("/m/", "/p/"),
            params: to.params,
            query: to.query
          });
        }
      },
      component: () => import("@/Layout/mobile.vue"),
      children: [
        {
          path: "video",
          name: "newVideoShare",
          meta: {
            title: "晓讲师"
          },
          component: () => import("@/components/newVideoShare/index.vue")
        },
        {
          path: "home",
          name: "home",
          meta: {
            title: "个人主页",
          },
          component: () => import("../components/newHomepage")
        },
        {
          path: "my",
          name: "my",
          meta: {
            title: "我的",
            auth:true

          }, 
          beforeEnter:(to,from,next)=>{
            if(localStorage.getItem('token')){
                next()
              }else{
                next({
                  path:"/mobileLogin"
                })
            }
          },

          component: () => import("@/views/mobile/My.vue")
        },
          {
          path: "history",
          name: "history",
          meta: {
            title: "历史记录",
            auth:true

          },
          beforeEnter:(to,from,next)=>{
          if(localStorage.getItem('token')){
              next()
            }else{
              next({
                path:"/mobileLogin"
              })
            }
          },
          component: () => import("@/views/mobile/History.vue")
        }
      ]
    },
    {
      path: "/mobileLogin",
      name: "mobileLogin",
      component: () => import("@/views/mobile/Login/index.vue")
    },

    // {
    //   path: "/creator",
    //   name: "Creator",
    //   meta: {
    //     title: "创作者服务",
    //     type: "creator"
    //   },

    //   component: () => import("@/components/creator/index.vue")
    // }
  ]
});
router.onError(error => {
  console.log(error);
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js